package com.oratakashi.web.components.widgets

import androidx.compose.runtime.Composable
import com.oratakashi.web.resources.R
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

@Composable
fun TimelineView() {
    Column(
        verticalArrangement = Arrangement.SpaceBetween
    ) {
        TimelineItemView()
        TimelineItemView()
        TimelineItemView()
    }
}

@Composable
fun TimelineItemView() {
    Row(
        modifier = Modifier
            .width(100.percent)
    ) {
        Column(
            modifier = Modifier
                .display(DisplayStyle.Flex)
        ) {
            Surface(
                modifier = Modifier
                    .width(4.px)
                    .height(150.px)
                    .background(R.colors.PRIMARY_500.value)
            ) {}
        }
        Column (
            modifier = Modifier
                .width(100.percent)
                .height(100.px)
                .margin(left = 1.5.cssRem, top = 0.8.cssRem)
                .background(R.colors.CARD_BACKGROUND_LIGHT.value)
                .borderRadius(R.dimens.BORDER_RADIUS.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = R.colors.PRIMARY_200.value
                )
                .boxShadow(
                    color = R.colors.SHADOW_COLORS.value.toRgb().copy(alpha = 20),
                    blurRadius = 20.px,
                    spreadRadius = 15.px
                )
        ) {
            SpanText("Lorem Ipsum")
        }
    }
}